import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/import-transactions')({
  component: Outlet,
  head: () => ({ meta: [{ title: 'Import Transactions' }] }),
});
